import { Stack } from "@mui/material";
import React, { useState } from "react";
import { NewContent } from "../../../components/Content/NewContent";
import { NewContentForm } from "../../../components/Content/NewContentForm";
import { SmartContainer } from "../../../styles/Containers";
import { StyledModal } from "../../../styles/matieralui/Modal";
import { StyledTab, StyledTabPanel, StyledTabs } from "../../../styles/matieralui/Tabs";
import { StyledH1 } from "../../../styles/StyledHTML";
import { LibraryList } from "./LibraryList";
import { createLibrary } from "./redux/library.actions";
import { FullLibraries } from "./redux/library.selectors";
import { TERM_LIBRARY } from "../../services/CaptureCollabService";
export const SelectOrCreateLibrary = ({ open = false, onClose, onChange }) => {
    const store = FullLibraries();
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event, index) => setActiveTab(index);
    const handleChange = (v) => {
        if (!onChange) return;
        onChange(v);
    }

    return (
        <StyledModal mediumWidth={true} open={open} onClose={() => onClose(false)}>

            <Stack>

                <SmartContainer flex align="center" justify="center">
                    <StyledH1>Select or Create a {TERM_LIBRARY}</StyledH1>
                </SmartContainer>

                <StyledTabs variant="fullWidth" centered indicatorColor="primary" value={activeTab} onChange={handleTabChange} aria-label="Edit Form" scrollButtons="auto">
                    <StyledTab label={`Select A ${TERM_LIBRARY}`} id="screen-1" key="screen-1" aria-controls="screen-1" />
                    <StyledTab label={`Create A ${TERM_LIBRARY}`} id="screen-2" key="screen-2" aria-controls="screen-2" />
                </StyledTabs>

                <StyledTabPanel value={activeTab} index={0}>
                    <LibraryList onSelect={handleChange} noControls={true} />
                </StyledTabPanel>

                <StyledTabPanel value={activeTab} index={1}>
                    <NewContentForm titleLabel={`New ${TERM_LIBRARY} Name`} helper={`Enter the name of the new ${TERM_LIBRARY} or select one below`} selector={FullLibraries} createAction={createLibrary} />
                </StyledTabPanel>

            </Stack>

        </StyledModal>
    )
}